export default __webpack_public_path__ + "static/media/loan pools 1.04303be6.svg";